import { CButton, CFormCheck, CFormLabel } from '@coreui/react'
import { Plus } from 'lucide-react'
import React, { useEffect, useState } from 'react'
import { CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react'
import SaveExtra from '../../services/general/saveExtraData.api'
import Graytextarea from '../../components/Graytextarea'
import toast from 'react-hot-toast'

const PatientDifferentialDiagnosis = ({ diagnosisName, saveTreatsShell, isAllotedToProvider, setSelectedDifferentialDiagnosis, noteStructureRef, showTreatmentAsAccordion }) => {
  const [visible, setVisible] = useState(false)
  const [value, setValue] = useState('')
  const [suggestions, setSuggestions] = useState([])
  const [selectedSuggestion, setSelectedSuggestion] = useState([])
  const [editDdx, setEditDdx] = useState(false)
  const [editTempDdx, setEditTempDdx] = useState('')

  useEffect(() => {
    const ddxValues = (noteStructureRef?.current && noteStructureRef?.current?.patientDifferentialDiagnosis && noteStructureRef?.current?.patientDifferentialDiagnosis[diagnosisName] && noteStructureRef?.current?.patientDifferentialDiagnosis[diagnosisName]) || ''
    if (ddxValues && ddxValues.length > 0) {
      if (typeof ddxValues === 'string' && ddxValues.trim().length > 0) {
        const ddxArray = ddxValues
          .split('\n')
          .map((item) => item.trim())
          .filter((item) => item.length > 0)

        setSelectedSuggestion(ddxArray)
        setEditTempDdx(ddxValues)
        setValue(ddxValues)
      }
    }
  }, [noteStructureRef?.current, visible, editDdx])

  const getAllDiagnosisDifferential = async () => {
    let data = await SaveExtra('Get_By_Type', 'differentialDiagnosis', '', '')
    data = JSON.parse(data.d)?.Data || []

    if (data) {
      data = data.map((item) => ({
        Id: item.Id,
        Data: JSON.parse(item?.JsonData),
      }))
    }

    const findDiagnosisDifferential = data.find((item) => item?.Data?.diagnosis?.label === diagnosisName)

    if (findDiagnosisDifferential && findDiagnosisDifferential?.Data?.accordions && findDiagnosisDifferential?.Data?.accordions[0]?.suggestions?.suggestionName) {
      const suggestions = findDiagnosisDifferential.Data.accordions[0].suggestions.suggestionName

      setSuggestions(suggestions)
    }
  }

  useEffect(() => {
    getAllDiagnosisDifferential()
  }, [])

  return (
    <>
      {showTreatmentAsAccordion ? (
        <div style={{ marginLeft: '' }}>
          <div className="mt-2 d-flex gap-3 align-items-center">
            <h7>
              <b>Differential Diagnosis</b>
            </h7>
          </div>
          <hr />
          {value && (
            <div className="px-2">
              <div className=" mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                {value}
              </div>
            </div>
          )}
        </div>
      ) : (
        <div style={{ marginLeft: '' }}>
          <div className="mt-2 d-flex gap-3 align-items-center">
            <h7>
              <b>Differential Diagnosis</b>
            </h7>

          {isAllotedToProvider && (
              <CFormLabel
                className="d-flex mt-2 flex-column align-items-center justify-content-center shadow "
                onClick={() => setVisible((p) => !p)}
                style={{
                  width: '30px',
                  height: '30px',
                  borderRadius: '20px',
                  background: 'var(--ui-color-primary, #2b7cd3)',
                  cursor: 'pointer',
                }}
              >
                <Plus className="text-white" strokeWidth={2} size={15} />
              </CFormLabel>
            )}
          
          </div>
          <hr />
         
          <div>
            <Graytextarea height="20px" value={value} onClick={() => setEditDdx((p) => !p)} />
         
          </div>
        </div>
      )}
      <CModal visible={visible} alignment="center" backdrop="static" scrollable onClose={() => setVisible(false)} aria-labelledby="VerticallyCenteredScrollableExample2">
        <CModalHeader>
          <p className="p-0 m-0">Add Differential Diagnosis for {diagnosisName}</p>
        </CModalHeader>
        <CModalBody className="d-flex flex-column gap-2">
          {suggestions.length > 0 &&
            suggestions.map((item, idx) => {
              return (
                <div>
                  <CFormCheck
                    checked={selectedSuggestion.includes(item.name)}
                    onChange={(e) => {
                      if (selectedSuggestion.includes(item.name)) {
                        setSelectedSuggestion(selectedSuggestion.filter((i) => i !== item.name))
                      } else {
                        setSelectedSuggestion([...selectedSuggestion, item.name])
                      }
                    }}
                    id={item.name}
                    label={item.name}
                  />
                </div>
              )
            })}
        </CModalBody>
        <CModalFooter className="border-top p-2 m-0">
          <CButton variant="outline" color="secondary" onClick={() => setVisible(false)}>
            Close
          </CButton>
          <CButton
            onClick={(e) => {
              const existingLines = value
                .split('\n')
                .map((line) => line.trim())
                .filter(Boolean)
              const newLines = selectedSuggestion.filter((s) => !existingLines.includes(s))
              const finalValue = [...existingLines, ...newLines].join('\n')

              setValue(finalValue)
              setVisible(false)

              noteStructureRef.current = {
                ...noteStructureRef.current,
                patientDifferentialDiagnosis: {
                  ...noteStructureRef.current.patientDifferentialDiagnosis,
                  [diagnosisName]: finalValue,
                },
              }

              setSelectedSuggestion([])
              toast.success('Successfully Added')
            }}
            color="primary"
          >
            Save
          </CButton>
        </CModalFooter>
      </CModal>

      {/* edit text ddx */}
      <CModal visible={editDdx} onClose={() => setVisible(false)} aria-labelledby="LiveDemoExampleLabel">
        <CModalHeader>
          <CModalTitle id="LiveDemoExampleLabel">
  {editTempDdx?.trim() ? 'Edit Differential Diagnosis' : 'Add Differential Diagnosis'}
</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <Graytextarea
            value={editTempDdx}
            onChange={(e) => {
              // setValue(e.target.value)
              setEditTempDdx(e.target.value)
            }}
          />
        </CModalBody>
        <CModalFooter>
          <CButton variant="outline" color="secondary" onClick={() => setEditDdx(false)}>
            Close
          </CButton>
          <CButton
            onClick={async () => {
              noteStructureRef.current = {
                ...noteStructureRef.current,
                patientDifferentialDiagnosis: {
                  ...noteStructureRef.current.patientDifferentialDiagnosis,
                  [diagnosisName]: editTempDdx,
                },
              }
              setValue(editTempDdx)
              setEditDdx(false)
              await saveTreatsShell(false)
              toast.success('Successfully Saved')
            }}
            color="primary"
          >
            Save Changes
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default PatientDifferentialDiagnosis
